import { useTranslations } from 'next-intl'

import { Heading } from '../../common'
import { LocationMap } from '../location-map'
import { Props } from './index.pc'

export const MobileLocation = ({
  addrStreet,
  lat,
  lng,
  subwayStations,
}: Props) => {
  const t = useTranslations('room_detail')

  const hasNearbySubwayStations = subwayStations.length > 0

  return (
    <section className="space-y-4 px-4 py-10">
      <Heading size="small">{t('location.title')}</Heading>
      <p className="typo-body2 font-semibold text-gray-900">{addrStreet}</p>
      <div className="bg-gray-0 h-[240px] w-full overflow-hidden rounded-sm">
        <LocationMap lat={lat} lng={lng} />
      </div>
      {hasNearbySubwayStations && (
        <ul className="typo-body2 flex flex-wrap gap-2 text-gray-900">
          {subwayStations.map(station => (
            <li key={station}>
              <span className="bg-gray-0 typo-body2 block h-9.5 w-fit rounded-full px-3.5 py-2 font-semibold text-black">
                {station}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
